import './recurring-giving-options.scss';

import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Alert } from '@sola/ark-core/molecules/alert/alert.tsx';
import { RadioGroup } from '@sola/ark-core/molecules/radio-group/radio-group.tsx';
import { GraphQLCommitment } from '@sola/schema/dotcom/supporters/schema.generated.ts';
import { sortCommitmentsByPriority } from '@sola/supporter-sdk/utils/commitments.ts';

import { CommitmentAvatarGroup } from '../../molecules/commitment-avatar-group/commitment-avatar-group.tsx';

export enum RecurringGivingRadioOptionsEnum {
  Yes = 'Yes',
  No = 'No',
}

export type RecurringGivingOptionsProps = {
  commitments: GraphQLCommitment[];
};

export const RecurringGivingOptions: React.FC<RecurringGivingOptionsProps> = ({
  commitments,
}) => {
  const { t } = useTranslation('my');
  const [recurringGivingSelection, setRecurringGivingSelection] =
    useState<string>('');
  const sortedCommitments = sortCommitmentsByPriority(commitments, t);

  return (
    <div className="w-full flex flex-col gap-comfy-md">
      <Alert
        variant="warning"
        title={t('addPaymentMethod.recurringGiving.alert.title')}
        message={t('addPaymentMethod.recurringGiving.alert.message')}
        footer={
          <CommitmentAvatarGroup
            commitments={sortedCommitments}
            size="lg"
            itemsToShow={4}
            tooltipMessage={t(
              'addPaymentMethod.recurringGiving.alert.tooltip',
              {
                count: sortedCommitments.length,
              },
            )}
          />
        }
      />
      <div>
        <RadioGroup
          required
          label={t('addPaymentMethod.recurringGiving.radioGroup.title')}
          variant="boxed"
          name="recurringGiving"
          value={recurringGivingSelection}
          onChange={(e) => {
            setRecurringGivingSelection(e.target.value);
          }}
          items={[
            {
              value: RecurringGivingRadioOptionsEnum.Yes,
              element: (
                <span className="flex flex-col flex-wrap">
                  <span>
                    {t(
                      'addPaymentMethod.recurringGiving.radioGroup.actions.yes',
                    )}
                  </span>
                  <span className="RecurringGivingOptions__radio-subtitle label-moderate label-md">
                    {t(
                      'addPaymentMethod.recurringGiving.radioGroup.buttonMessage',
                    )}
                  </span>
                </span>
              ),
            },
            {
              text: t('addPaymentMethod.recurringGiving.radioGroup.actions.no'),
              value: RecurringGivingRadioOptionsEnum.No,
            },
          ]}
        />
      </div>
    </div>
  );
};
